import * as React from "react"
import {ToggleButtonSeeker} from "@ui-seeker/core";

import {topSellersTab} from "../@signals";
import {TOP_KPI} from "../constants";


const TOP_TABS = [
	{ value: TOP_KPI.PRODUCTS, label: 'Nº products' },
    { value: TOP_KPI.DISPERSION, label: 'Price Dispersion' }
]

export default function MarketplacesTopSellersToggleButton({ userUseRRSP }) {

    const tabsToShow = () => {
        if (!userUseRRSP)
            return TOP_TABS.filter(tab => tab.value === TOP_KPI.PRODUCTS)
        return TOP_TABS
    }

    return <ToggleButtonSeeker
        value={topSellersTab.value}
        tabs={tabsToShow()}
        onChange={(_, newValue) => topSellersTab.value = newValue}
    />
}